import { css, type CSSResult } from 'lit'

export const style: CSSResult = css``
